import React, { useEffect, useState } from "react";
import Circle2 from "./Circle2.js";
import classes from "./TeamLineups2.module.css";

const PlayerCell = ({ data, colorChange }) => {
    const { player } = data;
    return (
        <div className={classes.cellWrap}>
            <div className={classes.cellInner}>
                <Circle2 number={player?.number} count={player?.count} colorChange={colorChange} />
                <p className={classes.playerName}>{player.name}</p>
            </div>
        </div>
    );
};

const TeamLineups2 = ({ homeTeam, startXI }) => {
    const [grids, setGrids] = useState({ g1:[], g2:[], g3:[], g4:[], g5:[] });

    useEffect(() => {
        setGrids({
            g1: startXI?.filter(d => d?.player?.grid?.startsWith("1")) ?? [],
            g2: startXI?.filter(d => d?.player?.grid?.startsWith("2")) ?? [],
            g3: startXI?.filter(d => d?.player?.grid?.startsWith("3")) ?? [],
            g4: startXI?.filter(d => d?.player?.grid?.startsWith("4")) ?? [],
            g5: startXI?.filter(d => d?.player?.grid?.startsWith("5")) ?? [],
        });
    }, [startXI]);

    const rowOrder = homeTeam
        ? [grids.g1, grids.g2, grids.g3, grids.g4, grids.g5]
        : [grids.g5, grids.g4, grids.g3, grids.g2, grids.g1];

    return (
        <div className={classes.teamWrap}>
            {rowOrder.map((row, i) => (
                <div
                    key={i}
                    className={classes.row}
                    style={{ display: "grid", gridTemplateColumns: `repeat(${Math.max(row.length, 1)}, 1fr)` }}
                >
                    {row.map((data, j) => (
                        <PlayerCell key={j} data={data} colorChange={!homeTeam} />
                    ))}
                </div>
            ))}
        </div>
    );
};

export default TeamLineups2;